import { api } from "@/lib/api";

const g = (p, params) => api.get(`/admin/fb-lab${p}`, { params }).then((r) => r.data);
const p = (path, body) => api.post(`/admin/fb-lab${path}`, body).then((r) => r.data);

export const labStatus = () => g("/status");
export const createPairing = () => p("/pair");
export const revokeExtension = () => p("/extension/revoke");
export const downloadExtensionZip = async () => {
  try {
    const r = await api.get("/admin/fb-lab/extension.zip", { responseType: "blob" });
    if (!String(r.headers["content-type"] || "").includes("zip") || r.data.size < 1000) throw new Error("The server didn't send a ZIP file.");
    return r.data;
  } catch (e) {
    const b = e?.response?.data;
    if (b instanceof Blob) { try { e.response.data = JSON.parse(await b.text()); } catch { e.response.data = {}; } }
    throw e;
  }
};
export const labHorses = () => g("/horses");
export const getPackage = (hid) => g(`/horses/${hid}/package`);
export const retryVideo = (hid, key) => p(`/horses/${hid}/videos/${encodeURIComponent(key)}/retry`);
export const createJob = (body) => p("/jobs", body);
export const listJobs = () => g("/jobs");
export const listHorseJobs = (hid) => g("/jobs", { horse_id: hid });
export const resetCheck = (hid) => g(`/horses/${hid}/group-post-reset`);
export const resetGroupPost = (hid, body) => p(`/horses/${hid}/reset-group-post`, body);
export const cancelJob = (id) => p(`/jobs/${id}/cancel`);
export const resolveJob = (id, body) => p(`/jobs/${id}/resolve`, body);
export const listPosts = () => g("/posts");
export const linkPost = (body) => p("/posts", body);
export const syncPost = (id) => p(`/posts/${id}/sync`);
export const patchPost = (id, body) => api.patch(`/admin/fb-lab/posts/${id}`, body).then((r) => r.data);
export const postDetail = (id) => g(`/posts/${id}/detail`);
export const publicPreview = (id) => g(`/posts/${id}/public-preview`);
export const recheckAttribution = (id) => p(`/posts/${id}/recheck-attribution`);
export const reviewBid = (id, body) => p(`/bids/${id}/review`, body);
export const reactProbe = (cid) => p(`/comments/${cid}/react-probe`);
export const reactProbes = (cid) => g(`/comments/${cid}/react-probes`);
export const analytics = () => g("/analytics");
export const errText = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : d?.message || "Something went wrong";
};
